export const createPieces = (level, imageSize) => {
  let pieces = []; // The pieces shuffled for the game
  let shuffleArray = []; // Array with ordered possiton to be drawn the positons for image pieces
  let tempPieces = []; // Temporay array to store the postion of pieces and images

  for(let i = 0; i < 3; i++){
    for(let j = 0; j < 3; j++){
      // Add the position of pieces and images to tempPieces
      tempPieces.push({x: j,
                  y: i,
                  id:i*3+j,
                  image:{
                    imageX:j,
                    imageY:i,
                    id:i*3+j
                  }});
      // Add the ordered index to shuffleArray
      shuffleArray.push(i*3+j);
    }
  }

  for(let i = 0; i < 9; i++){
    // Drawn a pieces of shuffleArray
    let id = Math.floor(Math.random() * shuffleArray.length);
    let element = shuffleArray[id];

    // Add the piece in ordered way to the pieces array, exchenging the image position for that from of shaffleArry
    pieces.push({x:tempPieces[i].x,
                 y:tempPieces[i].y,
                 id:tempPieces[element].id,
                image:tempPieces[element].image});
    shuffleArray.splice( id, 1 );
  }

  return pieces;
};

export const isOrdered = pieces => {
  let result = true;

  for(let i = 0; i < pieces.length; i++){
    if(pieces[i].image.id !== i){
      result = false;
      break;
    }
  }
  return result;
};

// This method trade the value of two pieces and update the position of the target
export const tradePieces = (pieces, pieceA, pieceB) => {
  const a = pieceA.attrs.id;
  const b = pieceB.attrs.id;

  const temp = pieces[a].image;

  pieces[a].image = pieces[b].image;

  pieces[b].image = temp;

  return pieces;
};

export const updatePosition = (piece, pieceSize) =>{  
  piece.x(piece.attrs.coorX*pieceSize.width);
  piece.y(piece.attrs.coorY*pieceSize.height);
  
  return piece;
};
